let support: boolean | null = null

/**
 * Whether this browser can create the WebGL 2 context three.js needs (three only asks for `webgl2`).
 * Some browsers cannot: no GPU, hardware acceleration switched off, or a blocklisted driver.
 * Probed once per page load, browser only, so call it from an effect, never during render.
 * Check it before constructing any WebGLRenderer and show the scene's fallback when it is false.
 */
export const supportsWebGL = (): boolean => {
    if (support !== null) return support
    if (typeof document === 'undefined') return false

    try {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('webgl2')

        support = Boolean(context)

        // Hand the probe's context straight back so it never counts against the browser's limit.
        context?.getExtension('WEBGL_lose_context')?.loseContext()
    }
    catch {
        support = false
    }

    return support
}
